import WatchlistButton from 'src/components/filmwebid/WatchlistButton';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';
import styles from './NoProviders.module.css';

//#region [Props]
type NoProvidersProps = {
  streamingId: number;
};
//#endregion

//#region [Component]
const WLWatchlistButton = withWatchlistState(WatchlistButton)

export default function NoProviders({ streamingId }: NoProvidersProps) {
  return <div className={styles.NoProviders}>
    <WLWatchlistButton streamingId={streamingId} />
    <div>
      <p className={styles.Paragraph}>Ooops, vi finner ingen steder du kan streame denne akkurat nå.</p>
      <p className={styles.Paragraph}>Legg den i din huskeliste, så varsler vi deg når den blir tilgjengelig.</p>
    </div>
  </div>;
}
//#endregion

